import NumberHelper from '@/core/helpers/NumberHelper';
import MessageHelper from '@/core/helpers/MessageHelper';
import StringHelper from '@/core/helpers/StringHelper';
import { Result } from '@/core/models/Result';
import { ErrorMessage } from '@/core/constants/ErrorMessage';
import axios, { HttpStatusCode } from 'axios';
import LivestreamProductRepositoryInterface from '../interface-adapters/LivestreamProductRepositoryInterface';

function buildLivestreamProductByIdUrl(): string {
    const baseUrl = String(import.meta.env.VITE_API_URL ?? '').replace(/\/$/, '');
    const path = String(import.meta.env.VITE_GET_LIVESTREAM_PRODUCT_BY_ID_API_PATH ?? '');
    if (StringHelper.isHasValue(path) === false || path.startsWith('/') === false) {
        return '';
    }

    return `${baseUrl}${path}`;
}

export default class LivestreamProductRepository implements LivestreamProductRepositoryInterface {
    async get(id: number): Promise<Result<unknown>> {
        const result = new Result<unknown>();

        if (NumberHelper.isPositive(id) === false) {
            result.message = MessageHelper.format(ErrorMessage.POSITIVE_PARAMETER, 'id');
            result.responseCode = HttpStatusCode.BadRequest;
            return result;
        }

        const url = buildLivestreamProductByIdUrl();
        if (StringHelper.isHasValue(url) === false) {
            result.message = 'Missing VITE_GET_LIVESTREAM_PRODUCT_BY_ID_API_PATH';
            result.responseCode = HttpStatusCode.BadRequest;
            return result;
        }

        try {
            const {
                data: { success, message, data: responseData, customResponseCode },
            } = await axios.get<Result<unknown>>(url, {
                headers: {
                    'Content-Type': 'application/json',
                },
                params: { id },
            });

            if (success === true) {
                result.success = true;
            }
            if (StringHelper.isHasValue(message)) {
                result.message = message;
            }
            result.data = responseData;
            if (StringHelper.isHasValue(customResponseCode)) {
                result.customResponseCode = customResponseCode;
            }
        } catch (error: unknown) {
            if (error instanceof Error) {
                result.message = error.message;
            } else if (typeof error === 'string') {
                result.message = error;
            } else {
                result.message = 'Get livestream product failed';
            }
        }

        return result;
    }
}
